//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['list'],
}



// WEBPACK FOOTER //
// ./src/components/page3/Content.vue